import QuizOption from "./QuizOption";


export default function SingleQuiz({quiz, quizNumber, changeHandler, isQuizMark}) {
    return (
        <div className="quiz">
            <h4 className="question">Quiz {quizNumber} - {quiz.question}</h4>
            <div className="quizOptions">
              {quiz.options.map(option=> <QuizOption isQuizMark={isQuizMark} changeHandler={changeHandler} key={option.id} option={option} quizId={quiz.id}/>)}
            </div>
        </div>
    )
};